import 'regenerator-runtime/runtime';
import { createSearchModule } from './module';
import '../styles/demo.scss';
import { unmountComponentAtNode } from 'react-dom';
export default function ({ environment, jurisdiction, locale, translations }) {
    const searchModule = createSearchModule({
        cachePrefix: '$whSearch',
        locale,
        environment,
        jurisdiction,
        minQueryLength: 2,
        maxPreviousQueries: 5,
        maxPopularQueries: Infinity,
        supportSportFilter: true,
        featuredSports: ['OB_SP9', 'OB_SP43'],
        translations,
    });
    // Handle navigation
    searchModule.on('redirect', ({ url }) => {
        location.href = url;
    });
    // Store selections status in memory
    let selections = {};
    searchModule.on('oddClicked', (odd) => {
        selections = Object.assign(Object.assign({}, selections), { [odd.selection.id]: {
                fixed: odd.status && !odd.sp,
                sp: odd.status && odd.sp,
            } });
        searchModule.setSelectedSelections(selections);
    });
    // Inject Search UI into application
    const element = document.querySelector('#advanced-search-root') || document.createElement('div');
    if (!element.parentNode) {
        document.body.appendChild(element);
    }
    searchModule.render(element);
    // Silent HMR
    if (module.hot) {
        module.hot.accept();
    }
    return () => {
        searchModule.clearListeners();
        unmountComponentAtNode(element);
        element.remove();
    };
}
//# sourceMappingURL=demo.js.map